import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import type { TimeRangePreset } from "./presets";

interface PresetListProps {
  presets: TimeRangePreset[];
  selected: string | null;
  onSelect: (preset: TimeRangePreset) => void;
}

export const PresetList = ({
  presets,
  selected,
  onSelect,
}: PresetListProps) => (
  <Stack
    gap={0.5}
    align="stretch"
    className="w-full border-b p-2 sm:w-48 sm:border-r sm:border-b-0"
    role="group"
    aria-label="Preset ranges"
  >
    {presets.map((preset) => (
      <Button
        key={preset.label}
        variant="ghost"
        aria-pressed={selected === preset.label}
        className="justify-start font-normal aria-pressed:bg-selected aria-pressed:font-medium aria-pressed:text-brand"
        onClick={() => onSelect(preset)}
      >
        {preset.label}
      </Button>
    ))}
  </Stack>
);
